import React from 'react';

const TopBar = () => {
  return (
    <div className="top-bar">
      <div className="top-bar-content">
        <div className="logo-section">
          <img 
            src="/assets/trafalgar-logo.png" 
            alt="Trafalgar Logo" 
            className="top-bar-logo"
          />
          <span className="company-name">Trafalgar</span>
        </div>
        <div className="top-bar-title">
          <span>Orchestration Systems</span>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
